<template>
  <div id="november_2022" class="november_2022">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="toggle-btn absolute cursor-pointer p-6 block" @click="isMenu = !isMenu">
        <img src="~@/assets/images/202211/menubar/right.png" class="object-contain w-full">
      </a>

      <a class="cursor-default block px-3"><img src="~@/assets/images/202211/menubar/menu-bar-off_01.png" class="object-contain"></a>
      <a @click="toTop('#price')" class="hover-item cursor-pointer block px-3">
        <img src="~@/assets/images/202211/menubar/menu-bar-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202211/menubar/menu-bar-on_02.png" class="on object-contain">
      </a>
      <a @click="toTop('#mag')" class="hover-item cursor-pointer block px-3">
        <img src="~@/assets/images/202211/menubar/menu-bar-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202211/menubar/menu-bar-on_03.png" class="on object-contain">
      </a>
      <a @click="toTop('#bookSection')" class="hover-item cursor-pointer block px-3">
        <img src="~@/assets/images/202211/menubar/menu-bar-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202211/menubar/menu-bar-on_04.png" class="on object-contain">
      </a>
      <a @click="toTop('#writing')" class="hover-item cursor-pointer block px-3">
        <img src="~@/assets/images/202211/menubar/menu-bar-off_05.png" class="off object-contain">
        <img src="~@/assets/images/202211/menubar/menu-bar-on_05.png" class="on object-contain">
      </a>
      <a @click="toTop('#november_2022')" class="hover-item cursor-pointer block px-3">
        <img src="~@/assets/images/202211/menubar/menu-bar-off_06.png" class="off object-contain">
        <img src="~@/assets/images/202211/menubar/menu-bar-on_06.png" class="on object-contain">
      </a>
    </div>

    <section class="banner py-6" id="banner">
      <div class="container max-w-6xl mx-auto px-4">
        <div>
          <img src="~@/assets/images/202211/LiveABC-logo.png" class="object-contain">
        </div>
        <div>
          <img src="~@/assets/images/202211/master-visual.png" class="object-contain mx-auto">
        </div>
        <div class="-mt-5 md:-mt-8 lg:-mt-12" id="price">
          <img src="~@/assets/images/202211/sale-info.png" class="object-contain mx-auto">
        </div>
      </div>
    </section>
    <section class="labels py-6" id="labels">
      <div class="container max-w-6xl mx-auto px-4">
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 p-3">
            <img src="~@/assets/images/202211/sale-button-03.png" class="object-contain mx-auto">
          </div>
          <div class="w-full md:w-1/3 p-3">
            <img src="~@/assets/images/202211/sale-button-02.png" class="object-contain mx-auto">
          </div>
          <div class="w-full md:w-1/3 p-3">
            <img src="~@/assets/images/202211/sale-button-01.png" class="object-contain mx-auto">
          </div>
        </div>
        <div class="w-full text-white flex justify-center">
          <a href="" class="block py-4 text-xl">立即選購 ▶ 再把大獎帶回家</a>
        </div>
      </div>
    </section>
    <section class="magazine py-6" id="mag">
      <div class="container max-w-6xl mx-auto px-4">
        <div class="flex flex-wrap">
          <div class="w-full mb-4">
            <img src="~@/assets/images/202211/magazine-title-01.png" class="object-contain mx-auto hidden md:block w-full">
            <img src="~@/assets/images/202211/magazine-title-01-mobile.png" class="object-contain mx-auto md:hidden w-full">
          </div>

          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-1/2 lg:w-1/3 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in planData" :key="idx">

            <div class="item-inner bg-white rounded-lg p-4 h-full flex flex-col justify-between border-2 border-blue" v-if="renderComponent">
              <div class="item relative">
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                    <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
              </div>

              <div class="mag-title mt-5 flex flex-col justify-center items-center">
                <div class="mb-3">
                  <img :src="item.logo_url" alt="livaABC" class="w-full h-auto object-contain block">
                </div>
                <div>
                  <p class="github-purple font-bold">{{ item.text }}</p>
                </div>
              </div>

              <div class="line my-4"></div>

              <div class="price github-purple px-3">
                <p class="text-xs line-through">現省{{ Number(item.plan[0].fixed_price) - Number(item.plan[0].pricing) }}</p>
                <div class="flex flex-wrap justify-between items-center">
                  <p class="flex items-end mb-0">
                    <span class="text-4xl font-bold">$</span>
                    <span class="text-4xl github-red font-bold">{{ Number(item.plan[0].pricing) }}</span>
                    <span class="mb-1 ml-1">/套</span>
                  </p>
                  <a href="https://store.liveabc.com/products/package/sale?tag=196"> <img src="~@/assets/images/202211/buy-button-blue.png" class="object-contain mx-auto w-full inline-block"></a>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <section class="book py-6" id="bookSection">
      <div class="container max-w-6xl mx-auto px-4">
        <div class="flex flex-wrap">
          <div class="w-full mb-4">
            <img src="~@/assets/images/202211/bools-title-02.png" class="object-contain mx-auto hidden md:block w-full">
            <img src="~@/assets/images/202211/bools-title-02-mobile.png" class="object-contain mx-auto md:hidden w-full">
          </div>

          <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 lg:w-1/3 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in bookData" :key="idx">

            <div class="item-inner bg-white rounded-lg p-6 lg:p-8 h-full flex flex-col justify-between items-center border-2 border-blue" v-if="renderComponent">
              <div class="w-full">
                <div class="item-label mb-3 github-purple text-center">
                  <p class="font-bold">{{ item.text }}</p>
                  <p class="font-black text-lg">{{ item.name }}</p>
                </div>
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                    <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
                <div class="line my-4"></div>

                <div class="price github-purple px-3">
                  <p class="text-xs line-through">現省{{ item.pricing - item.newPricing }}</p>
                  <div class="flex flex-wrap justify-between items-center">
                    <p class="flex items-end mb-0">
                      <span class="text-4xl font-bold">$</span>
                      <span class="text-4xl github-red font-bold">{{ item.newPricing }}</span>
                      <span class="mb-1 ml-1">/套</span>
                    </p>
                    <a href=""> <img src="~@/assets/images/202211/buy-button-black.png" class="object-contain mx-auto w-full inline-block"></a>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="flex items-center justify-center py-6">
          <p class="text-3xl github-purple font-medium">點我看更多優惠▶</p>
          <a href="https://store.liveabc.com/products/magazine/sale?tag=196" class="inline-block github-purple py-3 px-4 border-2 rounded-lg bg-white mx-2 font-semibold text-xl github-purple-border">更多優惠</a>
        </div>
      </div>
    </section>
    <section class="writing py-6" id="writing">
      <div class="container max-w-6xl mx-auto px-4">
        <div class="main">
          <div class="w-full mb-4 md:-mt-6 lg:-mt-8 xl:-mt-12">
            <img src="~@/assets/images/202211/pigai-title-03.png" class="object-contain mx-auto hidden md:block w-full">
            <img src="~@/assets/images/202211/pigai-title-03-mobile.png" class="object-contain mx-auto md:hidden w-full">
          </div>

          <div class="p-6">
            <p class="text-3xl text-center font-bold tracking-wider mb-4 github-purple">隨時隨地上網就能練習寫作，24小時線上專屬家教！</p>

            <div class="flex flex-wrap">
              <div class="w-full md:w-1/3 p-4">
                <div><img src="~@/assets/images/202211/pigai-icon-01.png" class="object-contain mx-auto w-full"></div>
              </div>
              <div class="w-full md:w-1/3 p-4">
                <div><img src="~@/assets/images/202211/pigai-iocn-02.png" class="object-contain mx-auto w-full"></div>
              </div>
              <div class="w-full md:w-1/3 p-4">
                <div><img src="~@/assets/images/202211/pigai-iocn-03.png" class="object-contain mx-auto w-full"></div>
              </div>
            </div>

            <div class="line my-4 relative"></div>

            <div class="flex flex-wrap">
              <a class="w-full p-4" href="https://store.liveabc.com/products/package/sale?tag=195">
                <div><img src="~@/assets/images/202211/pigai-order.png" class="object-contain mx-auto hidden md:block w-full"></div>
                <div><img src="~@/assets/images/202211/pigai-mobile-order.png" class="object-contain mx-auto md:hidden w-full"></div>
              </a>
            </div>

          </div>
        </div>
      </div>
    </section>
    <section class="event_text py-6">
      <div class="container max-w-6xl mx-auto font-semibold px-4">
        <h6 class="text-2xl mb-4">LiveABC狂嗨購物節滿額抽獎活動辦法：</h6>
        <ul class="list-decimal list-inside leading-loose">
          <li>2022.11.1~2022.12.11於LiveABC官方網站及紙本訂購單購買商品滿1111元，訂單成立並完成付款後即符合抽獎資格，1筆訂單可參與抽獎乙次（以訂單編號為主）。</li>
          <li>將於2022.12.20抽出乙名得主，公告於LiveABC官方網站及官方臉書粉絲團。</li>
          <li>活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格，不予另行通知。</li>
          <li>中華民國稅法規定，中獎贈品或獎金原價超過市價新台幣1,000元，年度報稅時須計入個人所得，故中獎人於領獎後、所得稅徵收前，將會收到本公司所發出之扣繳憑證。</li>
          <li>本活動之抽獎贈品不得轉換、轉讓他人或折換現金。</li>
          <li>如提供獎項因故無法取得，本公司保留替換其他等值獎項及變更、修改本活動之權利，並將最新變更後內容公布於官網活動頁面，不再個別提醒/通知客戶本活動內容之變更。</li>
        </ul>
      </div>
    </section>
    <section class="footer py-6">
      <div class="container max-w-6xl mx-auto">
        <div class="right text-white text-center py-3 mb-4 text-lg px-4">
          <p>本活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
        </div>
        <div class="more text-xl">
          <p class="text-center text-xl md:text-3xl github-purple font-medium">更多優惠都在LiveABC官網 >>
            <router-link :to="{ name: 'index' }" class="inline-block github-purple py-3 px-4 border-2 rounded-lg bg-white mx-2 font-semibold text-lg md:text-xl github-purple-border">前往官網</router-link>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import jump from 'jump.js'
import axios from 'axios'
export default {
  name: 'November_2022',
  metaInfo () {
    return {
      title: '滿額抽Dyson｜LiveABC 1111狂嗨購物節',
      titleTemplate: null
    }
  },
  components: {
  },
  data () {
    return {
      isMenu: true,
      renderComponent: true,
      planData: [
        { id: 6968, type: 'abc', introduction: '初級/基礎/活用', text: '打好英語基礎的最佳選擇！', logo_url: require('@/assets/images/202211/ABC.png') },
        { id: 6970, type: 'live', introduction: '中級/生活/實用', text: '日常生活實用英語輕鬆學！', logo_url: require('@/assets/images/202211/LIVE.png') },
        { id: 6972, type: 'all', introduction: '中高級/進階/應用', text: '閱讀寫作訓練豐富又多元！', logo_url: require('@/assets/images/202211/ALL.png') },
        { id: 6974, type: 'cnn', introduction: '新聞/時事/新知', text: '托福、多益檢測超必備！', logo_url: require('@/assets/images/202211/CNN.png') },
        { id: 6976, type: 'jp', introduction: '初級/生活/實用', text: '自學日語最佳輔助教材！', logo_url: require('@/assets/images/202211/JAPAN.png') },
        { id: 6978, type: 'hiw', introduction: '圖解/百科/符合108課綱', text: '團購秒殺搶購，佳評如潮！', logo_url: require('@/assets/images/202211/HIW.png') }
      ],
      bookData: [
        { id: 7796, text: '符合108課綱！小學英語檢測必備', newPricing: 2928 },
        { id: 7412, text: 'CNN官方授權！征服進階英語就靠他', newPricing: 2893 },
        { id: 6569, text: '道地口語英語！ 再也不怕開不了口', newPricing: 2661 },
        { id: 8122, text: '', newPricing: 714 },
        { id: 7389, text: '', newPricing: 667 },
        { id: 7954, text: '', newPricing: 1222 }
      ]
    }
  },
  mounted () {
    this.getEvent()
  },
  methods: {
    async getEvent () {
      let self = this
      await self.getData(self.planData)
      await self.getData(self.bookData)
    },

    getData (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}&pageSize=10`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },

    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      console.log(n)
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.github-purple {
  color: #01005C;
}
.github-purple-border {
  border-color: #01005C;
}
.github-red {
  color: #D73A49;
}
.outer {
  position: relative;
  width: 100%;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
#november_2022 {
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .toggle-btn {
    top: 20%;
    left: -40%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .banner {
    background: #FFEB3B;
  }
  .labels {
    background: #01005C;
  }
  .magazine {
    .item-inner {
      border: 2px solid #01005C;
      background: linear-gradient(180deg, rgba(255, 235, 59, 0) 0.21%, rgba(255, 235, 59, 0.2) 100%), #FFFFFF;
      .item {
        &:after{
          content: "";
          background-image: url('~@/assets/images/202211/Group31.png');
          background-size: contain;
          background-repeat: no-repeat;
          position: absolute;
          width: 64px;
          height: 65px;
          z-index: 10;
          right: 0%;
          bottom: -5%;
        }
        .outer {
          .inner {
            img {
              filter: drop-shadow(10px 10px 0px rgba(0, 0, 0, 0.25));
            }
          }
        }
      }
      .line {
        border-top: 2px dashed #01005C;
        height: 0;
      }
    }
  }
  .book {
    background: #FEF1C9;
    .item {
      .item-inner {
        border: 2px solid #01005C;
        .item-label {
          min-height: 48px;
        }
      }
    }
    .line {
      border-top: 2px dashed #01005C;
      height: 0;
    }

  }
  .writing {
    .main {
      background: #FEF1C9;
      border: 5px solid #01005C;
      border-radius: 48px;
      .line {
        border-top: 2px dashed #01005C;
        height: 0;
        &:before{
          content: "";
          position: absolute;
          width: 10px;
          height: 10px;
          z-index: 10;
          left: 0%;
          bottom: 0%;
          background: #01005C;
          border-radius: 50%;
          top: 50%;
          transform: translateY(-50%);
        }
        &:after{
          content: "";
          position: absolute;
          width: 10px;
          height: 10px;
          z-index: 10;
          right: 0%;
          top: 50%;
          transform: translateY(-50%);
          background: #01005C;
          border-radius: 50%;
        }
      }
    }
  }
  .event_text {
    color: #01005C;
  }
  .footer {
    .right {
      background: #01005C;
    }
    .more {
      color: #01005C;
    }
  }
}
</style>
